import { DICTATION_BAR_COUNT } from './dictationConstants.js'
import { fillLevels } from './fillLevels.js'
import { pickMimeType } from './pickMimeType.js'

export async function startDictationSession({ cancelled, levelsRef, setLevels, sessionRef, onError }) {
  const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
  if (cancelled()) {
    stream.getTracks().forEach((t) => t.stop())
    return
  }

  const Ctx = window.AudioContext || window.webkitAudioContext
  const ctx = new Ctx()
  await ctx.resume().catch(() => {})
  const analyser = ctx.createAnalyser()
  analyser.fftSize = 512
  analyser.smoothingTimeConstant = 0.72
  ctx.createMediaStreamSource(stream).connect(analyser)

  const mimeType = pickMimeType()
  const recorder = mimeType ? new MediaRecorder(stream, { mimeType }) : new MediaRecorder(stream)
  const chunks = []
  recorder.ondataavailable = (e) => {
    if (e.data.size > 0) chunks.push(e.data)
  }
  recorder.start(250)

  const freqData = new Uint8Array(analyser.frequencyBinCount)
  const session = { stream, ctx, analyser, recorder, chunks, rafId: 0, rafCount: 0 }
  sessionRef.current = session

  const loop = () => {
    if (cancelled() || sessionRef.current !== session) return
    analyser.getByteFrequencyData(freqData)
    fillLevels(freqData, levelsRef.current)
    session.rafCount += 1
    if (session.rafCount % 2 === 0) {
      setLevels(() => {
        const next = new Float32Array(DICTATION_BAR_COUNT)
        next.set(levelsRef.current)
        return next
      })
    }
    session.rafId = requestAnimationFrame(loop)
  }
  session.rafId = requestAnimationFrame(loop)
}
